module.exports = __webpack_public_path__ + "images/help_v2/icon-pdf@2x-5e7fbd7758f4b062f78f983144696f1b.png";